<template>
  <div class="no-change-block">

    <product-filters
        v-if="products.length"
        :filters="filters"
        :brands="brands"
        :price-filter="priceFilter"
        @apply-filters="applyFilters"
        ref="productFilter"
    />

    <product-list-sort
        v-if="products.length"

        @change-view-type="changeViewType"
        @change-on-page="changeOnPage"
        @change-sort="changeSort"

        :sort-type="sortType"

        :count="filteredProducts.length"

        ref="productListSort"
    />

    <div class="bootstrap"  v-if="viewType === 'list'">
        <div class="table-responsive">
          <table class="table">
            <tr>
              <th><div class="catList_item_inf_name">Название</div></th>
              <th><div class="catList_item_inf_name">Бренд</div></th>
              <th><div class="catList_item_inf_name">Артикул</div></th>
              <th><div class="catList_item_inf_name">Код</div></th>
              <th><div class="catList_item_inf_name">Сток</div></th>
              <th><div class="catList_item_inf_name">Цена</div></th>
            </tr>
            <tr v-for="product in sortedProducts" :key="product.id">
              <td>
                <a :href="'/catalog/item/' + (category.catalog_code ? category.catalog_code + '/' : '') + product.id + '/' + product.human_url" class="catList_item_name">
                  {{ product.name }}
                </a>
                <div class="catList_item_cats">
                  <a :href="'/catalog/item/' + (category.catalog_code ? category.catalog_code + '/' : '') + product.id + '/' + product.human_url" class="catList_item_cats_cat text-orange" v-if="product.is_new">Новинка</a>
                  <a :href="'/catalog/item/' + (category.catalog_code ? category.catalog_code + '/' : '') + product.id + '/' + product.human_url" class="catList_item_cats_cat" v-if="product.has_discount">скидка</a>
                  <a :href="'/catalog/item/' + (category.catalog_code ? category.catalog_code + '/' : '') + product.id + '/' + product.human_url" class="catList_item_cats_cat" v-if="product.is_top">выбор покупателей</a>
                </div>
              </td>
              <td>
                <div class="catList_item_inf_value">
                  {{ product.brand_name }}
                </div>
              </td>
              <td>
            <span class="catList_item_name">
                <div class="catList_item_inf_value">
                    {{ product.articul }}
                </div>
            </span>
              </td>
              <td>
            <span class="catList_item_name">
                <div class="catList_item_inf_value">
                    {{ product.code }}
                </div>
            </span>
              </td>
              <td>
                <div class="catList_item_inf_name" v-if="!product.has_stock">
                  {{ product.smart_stock_label }}
                </div>
                <div class="catList_item_inf_value" v-if="product.has_stock">
                  {{ product.smart_stock }}
                </div>
              </td>
              <td>
                <div class="catList_item_price_value">
                  <money :price="product.current_price" />
                </div>
                <div class="catList_item_price_old" v-if="product.has_discount">
                  <money :price="product.base_price" />
                </div>
              </td>
            </tr>
          </table>
        </div>
    </div>

    <div class="catList" v-if="viewType === 'grid'">

      <div class="content border" v-if="productsOnPage.length">
        <div class="catList_typePos" :class="viewType">
          <product
              :product="product"
              :category="category"
              v-for="product in productsOnPage"
              :key="product.id"
              :basePath="basePath"
          />
        </div>
        <a v-if="isShowMoreButton" href="javascript:void(0)" @click="showMore()"
           class="catList_showMore hoverLineMoved">Показать еще</a>
      </div>
      <div class="bootstrap content border" v-else>
        <p>&nbsp;</p>
        <h5>Не найдены товары, удовлетворяющие условию</h5>
        <p>&nbsp;</p>
      </div>
      <div v-waypoint="{ active: true, callback: showMoreDebounce }"></div>
      <div class="content border" v-if="linkedProducts && linkedProducts.length">
        <h6 class="title font-size-90" >Похожие товары</h6>
        <div class="catList_typePos" :class="viewType">
          <product
              :product="product"
              :category="category"
              v-for="product in linkedProducts"
              :key="product.id"
              :basePath="basePath"
          />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import ProductListSort from "./ProductListSort"
import Product from "./Product"
import {_} from 'vue-underscore'
import ProductFilters from "./ProductFilters"
import Money from "@/components/core/Money.vue";

const DEFAULT_SORT = 'popularity'

export default {
  name: 'ProductList',
  components: { Money, ProductFilters, Product, ProductListSort},
  props: ['products', 'filters', 'brands', 'priceFilter', 'category', 'linkedProducts', 'basePath', 'categoryExtraParams'],
  data() {
    return {
      userFilters: null,
      viewType: 'grid',
      onPage: 12,
      onPageIteration: 1,
      sortType: DEFAULT_SORT
    }
  },
  mounted: function () {
    this.parseUri()
    let vm = this
    window.onpopstate = function () {
      vm.parseUri()
    }
  },
  methods: {
    parseUri() {
      if (document.location.search) {
        const filterParams = JSON.parse(decodeURI(document.location.search.split('&')[0]).substr(1))

        this.viewType = filterParams['vt'] ? filterParams['vt'] : 'grid'
        this.onPage = filterParams['op'] ? filterParams['op'] : 12
        this.sortType = filterParams['st'] || this.categoryExtraParams?.sort?.[0] || DEFAULT_SORT

        if (filterParams['uf']) {
          let userFilters = {}
          let userFilterSet = false

          if (filterParams['uf']['pr']) {
            userFilters.price = filterParams['uf']['pr']
            userFilterSet = true
          }
          if (filterParams['uf']['br']) {
            userFilters.brand = filterParams['uf']['br']
            userFilterSet = true
          }
          if (filterParams['uf']['ot']) {
            userFilters.other = {}
            for (const [key, value] of Object.entries(filterParams['uf']['ot'])) {
              if (_.isArray(value) && value.length) {
                userFilters.other[key] = value
                userFilterSet = true
              }
            }
          }
          if (userFilterSet) {
            this.userFilters = userFilters
          }
        }

        if (filterParams['opt'] && filterParams['opt'] > 3) {
          this.onPageIteration = filterParams['opt']
        } else {
          this.onPageIteration = 3;
        }

        this.$refs.productListSort.setViewType(this.viewType)
        this.$refs.productListSort.setOnPage(this.onPage)
        this.$refs.productListSort.setSortType(this.sortType)
        this.$refs.productFilter.setParams(this.userFilters)


      }
      this.sortType = this.categoryExtraParams?.sort?.[0] || DEFAULT_SORT
    },
    changeViewType(viewType) {
      this.viewType = viewType;
      this.appleHistoryState()
    },
    changeOnPage(onPage) {
      this.onPage = onPage;
      this.onPageIteration = 1;
      this.appleHistoryState()
    },
    changeSort(sortType) {
      if (this.sortType == sortType) return
      this.sortType = sortType;
      this.appleHistoryState()

      // this.onPageIteration = 1;
    },
    showMore() {
      this.onPageIteration++
    },
    showMoreDebounce: _.debounce(function () {
      this.showMore()
    }, 500),
    applyFilters(filters) {
      this.userFilters = filters
      this.$log('Filters:', filters)
      this.appleHistoryState()
    },
    appleHistoryState() {
      let uf = {}

      if (this.userFilters && this.userFilters.price && this.userFilters.price.length) {
        uf.pr = this.userFilters.price
      }

      if (this.userFilters && this.userFilters.brand && this.userFilters.brand.length) {
        uf.br = this.userFilters.brand
      }

      if (this.userFilters && this.userFilters.other) {
        uf.ot = {}
        for (const [key, value] of Object.entries(this.userFilters.other)) {
          if (_.isArray(value) && value.length) {
            uf.ot[key] = value
          }
        }
      }

      let currentState = {uf: uf};

      if (this.viewType != 'grid') {
        currentState.vt = this.viewType
      }

      if (this.onPage != 12) {
        currentState.op = this.onPage
      }

      if (this.onPageIteration != 1) {
        currentState.opt = this.onPageIteration
      }

      if (this.sortType != DEFAULT_SORT) {
        currentState.st = this.sortType
      }

      window.history.pushState(currentState, null, '?' + encodeURI(JSON.stringify(currentState)))

    }
  },
  computed: {
    productsOnPage() {
      return this.sortedProducts.slice(0, this.onPageIteration * this.onPage)
    },
    isShowMoreButton() {
      return this.onPageIteration * this.onPage <= this.filteredProducts.length
    },
    sortedProducts() {
      let products = this.filteredProducts
      switch (this.sortType) {
        case 'articul':
          products.sort((item1, item2) => {
            return item1.articul > item2.articul ? 1 : -1;
          })
          break;
        case 'code':
          products.sort((item1, item2) => {
            return item1.code > item2.code ? 1 : -1;
          })
          break;
        case 'priceasc':
          products.sort((item1, item2) => {
            if (item1.current_price.amount < item2.current_price.amount) {
              return -1;
            }
            if (item1.current_price.amount > item2.current_price.amount) {
              return 1;
            }
            return 0;
          })
          break;
        case 'pricedesc':
          products.sort((item1, item2) => {
            if (item1.current_price.amount < item2.current_price.amount) {
              return 1;
            }
            if (item1.current_price.amount > item2.current_price.amount) {
              return -1;
            }
            return 0;
          })
          break;
        case 'popularity':
          products.sort((item1, item2) => {
            if (!item1.popularity_index) {
              item1.popularity_index = 10000000;
            }
            if (!item2.popularity_index) {
              item2.popularity_index = 10000000;
            }

            if (item1.popularity_index < item2.popularity_index) {
              return -1;
            }
            if (item1.popularity_index > item2.popularity_index) {
              return 1;
            }
            return 0;
          })
          break;

        case 'sizes':
          products.sort((item1, item2) => {
            if (!item1.sizes_index) {
              item1.sizes_index = 10000000;
            }
            if (!item2.sizes_index) {
              item2.sizes_index = 10000000;
            }

            if (item1.sizes_index < item2.sizes_index) {
              return -1;
            }
            if (item1.sizes_index > item2.sizes_index) {
              return 1;
            }
            return 0;
          })
          break;

          // case 'discount':
          //     products.sort((item1, item2) => {
          //         if (item1.discount_percent < item2.discount_percent) {
          //             return 1;
          //         }
          //         if (item1.discount_percent > item2.discount_percent) {
          //             return -1;
          //         }
          //         return 0;
          //     })
          //     break;
          //
          // case 'isnew':
          //     products.sort((item1, item2) => {
          //         if (item1.is_new && !item2.is_new) {
          //             return -1;
          //         }
          //         if (!item1.is_new && item2.is_new) {
          //             return 1;
          //         }
          //         return 0;
          //     })
          //     break;
      }
      // products.sort((item1, item2) => {
      //     if (item1.has_stock && !item2.has_stock) {
      //         return -1;
      //     }
      //     if (!item1.has_stock && item2.has_stock) {
      //         return 1;
      //     }
      //     return 0;
      // })

      return products;
    },
    filteredProducts() {
      if (!this.userFilters) {
        return this.products
      }
      let products = this.products
      if (this.userFilters['price'] && this.userFilters['price'].length == 2) {
        this.$log('Apply Price Filter');
        products = _.filter(products, (product) => {
          return product.current_price.amount / 100 > this.userFilters['price'][0] && product.current_price.amount / 100 < this.userFilters['price'][1]
        })
      }
      if (this.userFilters['brand'] && this.userFilters['brand'].length > 0) {
        this.$log('Apply Brand Filter');
        products = _.filter(products, (product) => {
          return _.indexOf(this.userFilters['brand'], product.brand_name) > -1
        })
      }
      if (this.userFilters['in_stock_only']) {
        this.$log('Apply In Stock Filter');
        products = _.filter(products, (product) => {
          return product.has_stock
        })
      }
      Object.keys(this.userFilters['other']).forEach((key) => {
        if (_.isArray(this.userFilters['other'][key]) && this.userFilters['other'][key].length) {
          products = _.filter(products, (product) => {
            let isPassFilter = false;
            if (product.properties[key] && !isPassFilter) {
              product.properties[key].map(val => {
                if (_.indexOf(this.userFilters['other'][key], val) > -1) {
                  isPassFilter = true
                  return
                }
              });
            }
            return isPassFilter
          })
        } else if (_.isString(this.userFilters['other'][key]) && this.userFilters['other'][key]) {
          products = _.filter(products, (product) => {
            return product.properties[key] && this.userFilters['other'][key] == product.properties[key]
          })
        }
      });

      return products
    }
  }
}
</script>

<style>
body {
  overflow-anchor: none;
}
</style>
